// Libraries
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Admin } from '../models/Admin';
// Services
import { SessionService } from '../services/SessionService';
import { AdminService } from '../services/AdminService';

@Component({
    selector: 'admin-logout',
    template:   '',
    styles:     []
})

export class LogoutComponent {
    protected errorMessage: string;
    protected adminData: Admin;
    protected hostName: string;
    // For logout navigate
    protected devEnv: any = ['auth.eca.dev.nascorp.vn', 'camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn', 'reen.eca.dev.nascorp.vn'];
    protected testEnv: any = ['auth.eca.test.nascorp.vn', 'camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn'];
    protected stagingEnv: any = ['auth.eca.uat.nascorp.vn','services.eca.uat.nascorp.vn','asa.eca.uat.nascorp.vn','holidayschool.eca.uat.nascorp.vn','bus.eca.uat.nascorp.vn','outdooreducation.eca.uat.nascorp.vn','reen.eca.uat.nascorp.vn','acs.eca.uat.nascorp.vn','pcbs.eca.uat.nascorp.vn'];
    protected procEnv: any = ['auth.aisvietnam.com', 'outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com']

    constructor(
        protected router: Router,
        protected sessionService: SessionService,
        protected adminService: AdminService
        
    ) {}

    ngOnInit() {
        // Delete session from system
        
		this.hostName = window.location.hostname;
        this.deleteSession();
        this.adminData = this.adminService.getAdminSessionData();
    }

    /**
     * Delete user session data.
     */
    deleteSession() {
        this.sessionService.deleteAdminSession()
            .subscribe(
                complete => {
                    // Clear user session
                    this.adminService.clearAdminSessionData();
                    this.adminService.clearInterSession();
                    // Fire user session data changed event
                    this.adminService.adminDataChanged(null);
                    // Redirect to desired URL
                    if(this.devEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://services.eca.dev.nascorp.vn';
                    }
                    else if(this.testEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://services.eca.test.nascorp.vn';
                    }
                    else if(this.stagingEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'http://services.eca.uat.nascorp.vn';
                    }
                    else if(this.procEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = 'https://services.aisvietnam.com';
                    }
                    else{
                        return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
                    }
                },
                error    => this.errorMessage = <any> error
            );
    }

    // Redirect to desired url
    private redirect(redirectUrl: string) {
        this.router.navigate([redirectUrl]); 
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/admin/logout/LogoutComponent.ts